import { render, staticRenderFns } from "./DemandItemList.vue?vue&type=template&id=af2ad4b8&scoped=true"
import script from "./DemandItemList.vue?vue&type=script&lang=js"
export * from "./DemandItemList.vue?vue&type=script&lang=js"
import style0 from "./DemandItemList.vue?vue&type=style&index=0&id=af2ad4b8&prod&scoped=true&lang=css"
import style1 from "./DemandItemList.vue?vue&type=style&index=1&id=af2ad4b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2ad4b8",
  null
  
)

export default component.exports